module.exports = __webpack_public_path__ + "images/usermodule/01@2x.gif";


//////////////////
// WEBPACK FOOTER
// ./images/usermodule/01@2x.gif
// module id = 1569
// module chunks = 4